import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-状态标签",
  "use": "icon-状态标签-usage",
  "viewBox": "-13 13.8 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"-13 13.8 200 200\" id=\"icon-状态标签\">\r\n<path fill=\"#FFC107\" d=\"M159.7,13.8H-13l200,200V41C187,26,174.8,13.8,159.7,13.8z\" />\r\n<path fill=\"#FFA000\" d=\"M164.3,191v22.7H187L164.3,191z M-12.5,14v23.2h23.2L-12.5,14z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol